import { render, staticRenderFns } from "./OpeningTimes.vue?vue&type=template&id=64d8bf60&"
import script from "./OpeningTimes.vue?vue&type=script&lang=js&"
export * from "./OpeningTimes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports